<template>
  <label :class="{ 'c-switch': !loading }">
    <loading v-if="loading" no-margin></loading>
    <input
      v-else
      type="checkbox"
      :checked="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.checked, setLoading)"
    />
    <span :class="{ 'c-switch__slider': !loading }"></span>
  </label>
</template>

<script>
export default {
  name: "SwitchButton",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    setLoading(loading) {
      this.loading = loading;
    },
  },
};
</script>
